const authChannel = new BroadcastChannel('auth_channel');

authChannel.onmessage = (event) => {
  if (event.data.type === 'LOGIN' || event.data.type === 'LOGOUT') {
    window.location.reload();
  }
};

const logout = () => {
  authChannel.postMessage({ type: 'LOGOUT' });
};

const login = () => {
  authChannel.postMessage({ type: 'LOGIN' });
};

export const AuthChannel = {
  login,
  logout,
};
